/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {

  // Remove empty P tags created by WP inside of Accordion and Orbit
  jQuery('.accordion p:empty, .orbit p:empty').remove();

  // Adds Flex Video to YouTube and Vimeo Embeds
  jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
      jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
    } else {
      jQuery(this).wrap("<div class='responsive-embed'/>");
    }
  });

});

/********
 * Debounce function
 *
 * Returns a function, that, as long as it continues to be invoked, will not be triggered.
 * The function will be called after it stops being called for N milliseconds.
 * If `immediate` is passed, trigger the function on the leading edge, instead of the trailing.
 *
 * Reference: https://davidwalsh.name/javascript-debounce-function
 ********/

function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};



/******
 * Mobile and Desktop  Menu Switch
 *
 * Desktop Menu: Second level menu dropdown
 * Mobile Menu: Second level menu slide to open
 ******/
var menuState = "";
var mobileDesktopMenuSwitch = debounce(function() {
  if(menuState !== "mobile" && window.innerWidth < 1024) {
    menuState = "mobile";
    jQuery('.hamburger-icon').on('click', function(e){
      e.preventDefault();
      jQuery(this).toggleClass('active');
      jQuery(this).parents('.mobile-menu').toggleClass('first-level-open');
      jQuery('.mobile-menu').removeClass('second-level-open');
      jQuery('.menu-item-has-children').removeClass('open');
      jQuery('html').toggleClass('no-scroll');
    });

    jQuery('.menu-item-has-children > a').click(function(e){
      e.preventDefault();
      jQuery(this).parents('.mobile-menu').toggleClass('second-level-open');
      jQuery(this).parent().toggleClass('open');
    });

    jQuery('.menu-item-has-children > a').one('click', function(e){
      //This code onle need to run once
      jQuery(this).siblings('.second-level-menu').find('.second-level-parent').append(jQuery(this).clone());
    });

    jQuery('.mobile-menu .back-to-main').click(function(e) {
      jQuery('.mobile-menu').removeClass('second-level-open');
      jQuery('.menu-item-has-children').removeClass('open');
    });
  } else if(window.innerWidth >= 1024) {
    menuState = "desktop";
    jQuery('.hamburger-icon').off('click');
    jQuery('.menu-item-has-children > a').off('click');
    jQuery('.menu-item-has-children > a').off('click');
    jQuery('.second-level-menu .back').off('click');
  }
}, 250);

mobileDesktopMenuSwitch(); //run one on load
window.addEventListener('resize', mobileDesktopMenuSwitch);


/******
 * Smooth Scrolling
 ******/
jQuery('a[href*="#"]') // Select all links with hashes
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
      &&
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = jQuery(this.hash);
      target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        jQuery('html, body').animate({
          scrollTop: target.offset().top
        }, 700, function() {
          // Callback after animation
          // Must change focus!
          var $target = jQuery(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });



/******
 * Newsletter Sign Up
 ******/
//var everyN = 2;
//var isshow = localStorage.getItem('isshow');
//
//if (isshow  ==  undefined) {
//  localStorage.setItem('isshow', 1);
//  jQuery('#newsletter-subscription').foundation('open');
//} else if (isshow < everyN) {
//  //just add the number counts every different session
//  if(sessionStorage.getItem('isshow-session') == undefined) {
//    //add isshow number
//    isshow++;
//    localStorage.setItem('isshow', isshow);
//
//    //set session
//    sessionStorage.setItem('isshow-session', 1);
//  }
//} else {
//  localStorage.removeItem('isshow');
//}

